const DOMAIN = process.env.REACT_APP_DOMAIN;

export const Config = {
  //! @note Adjust project name, domains and URLs accordingly.
  'productName': 'Hoxa Status Page',
  'baseURL': 'https://status.hoxa.fr',

  //! @note The URL of the API webserver (/api/ folder in this repo)
  'apiURL': 'https://api.cron-job.org/',

  //! @note Domain to use whe opening the status page from localhost (e.g. dev environment)
  'domain': DOMAIN || 'dd00c3gv.status.cron-job.org',

  /****************************************************************************************
   ******** The following settings might be kept as is. Customization is optional. ********
   ****************************************************************************************/

  //! @note List of supported languages. When adding new language file, be sure
  //!       to add the new language code here.
  'languages': {
    'en': 'English',
    'fr': 'Français',
  },

  //! @note External status sources displayed below the cron-job monitors.
  //!       Supported types: 'statuspage' (Atlassian Statuspage), 'statusio' (Status.io),
  //!       and 'ocistatus' (Oracle Cloud Infrastructure Status).
  'externalSources': [
    {
      type: 'statuspage',
      name: 'Cloudflare',
      url: 'https://www.cloudflarestatus.com',
      componentId: '1km35smx8p41',
    },
    {
      type: 'statuspage',
      name: 'HelloAsso',
      url: 'https://status.helloasso.com'
    },
    {
      type: 'statuspage',
      name: 'Square',
      url: 'https://www.issquareup.com'
    },
    {
      type: 'statuspage',
      name: 'SumUp',
      url: 'https://status.sumup.com'
    },
    /*{
      type: 'statusio',
      name: 'Neon',
      statusioId: '6878fc85709daa75be6c7e3c',
    },*/
  ],

  //! @note Fallback language to use when the user's auto-determined language is not supported.
  'fallbackLanguage': 'en',
};
